export function BulkReverifyBar({
  selectedCount,
  isPending,
  onReverify,
  onClear,
}: {
  selectedCount: number;
  isPending: boolean;
  onReverify: () => void;
  onClear: () => void;
}) {
  if (selectedCount === 0) return null;
  return (
    <div
      className="card"
      style={{
        padding: '8px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        background: 'var(--brand-tint)',
      }}
    >
      <span>เลือก {selectedCount} ผู้ขาย</span>
      <button type="button" className="btn primary sm" disabled={isPending} onClick={onReverify}>
        {isPending ? 'กำลังตรวจซ้ำ…' : 'ตรวจสอบกับสรรพากรอีกครั้ง'}
      </button>
      <button type="button" className="btn ghost sm" onClick={onClear}>
        ยกเลิกการเลือก
      </button>
    </div>
  );
}
